import { useEffect } from "react";
import { Outlet } from "react-router";

import { isHandshakeEntryPath, removeBootShell } from "@/lib/boot-shell";

/**
 * Takes down the index.html loader once the routed UI has mounted. The layout
 * sits inside RouterProvider, below StatsigProviderWithSession (which renders
 * nothing until checkout/v3 resolves) and only commits together with the
 * matched page — for a lazy route that is after its chunk has downloaded, so
 * the loader never gives way to a blank page. /handshake keeps it:
 * WelcomeScreen reuses it until redirect.
 */
function RemoveBootShellOnMount(): null {
  useEffect(() => {
    if (!isHandshakeEntryPath()) removeBootShell();
  }, []);
  return null;
}

export function RootLayout(): React.JSX.Element {
  return (
    <>
      <RemoveBootShellOnMount />
      <Outlet />
    </>
  );
}

/**
 * Rendered while the initially matched route's chunk is still loading. Nothing
 * is painted on purpose: the index.html boot shell is still on the page and
 * stays there until RootLayout mounts.
 */
export function RootHydrateFallback(): null {
  return null;
}
